

export const fonts = {
  // فونت‌های فارسی
  vazir: {
    name: 'وزیر',
    family: "'Vazirmatn', sans-serif",
    isPersian: true,
    category: 'sans-serif',
    src: '@/assets/fonts/Vazir-FD-WOL.ttf'
  },
    pinar: {
    name: 'پینار',
    family: "pinar'', sans-serif",
    isPersian: true,
    category: 'sans-serif',
    src: '@/assets/fonts/Pinar.ttf'
  }
};

// تابع اعمال فونت
export function applyFont(fontKey) {
  const font = fonts[fontKey] || fonts.vazir;
  const root = document.documentElement;
  
  // حذف فونت قبلی
  const existingLink = document.getElementById('font-link');
  if (existingLink) {
    existingLink.remove();
  }
  
  // اضافه کردن فونت جدید اگر لینک دارد
  if (font.url) {
    const link = document.createElement('link');
    link.id = 'font-link';
    link.rel = 'stylesheet';
    link.URL = font.URL;
    document.head.appendChild(link);
  }
  
  // اعمال فونت خانواده
  root.style.setProperty('--font-family', font.family);
  
  localStorage.setItem('selectedFont', fontKey);
  
  return font;
}

// تابع بارگذاری فونت ذخیره شده
export function loadSavedFont() {
  const savedFont = localStorage.getItem('selectedFont') || 'vazir';
  return applyFont(savedFont);
}

// گرفتن لیست همه فونت‌ها
export function getFontsList() {
  return Object.entries(fonts).map(([key, value]) => ({
    id: key,
    name: value.name,
    family: value.family,
    isPersian: value.isPersian,
    category: value.category,
    src: value.src
  }));
}

// فیلتر فونت‌ها بر اساس دسته
export function getFontsByCategory(category) {
  return getFontsList().filter(font => font.category === category);
}

// فونت‌های فارسی
export function getPersianFonts() {
  return getFontsList().filter(font => font.isPersian);
}

// فونت‌های انگلیسی
export function getEnglishFonts() {
  return getFontsList().filter(font => !font.isPersian);
}